export default __webpack_public_path__ + "static/media/fish.5a33ff07.svg";